{
  "tasks.generated_by": "Generated by",
  "tasks.occurrence_of": "occurrence of {{value1}}",
  "tasks.occurrence_skipped": "Occurrence skipped",
  "tasks.placement_actions": "Placement actions",
  "tasks.routine_badge": "Routine",
  "tasks.routine_badge_title": "Generated by the routine {{value1}}",
  "planner.trash_task": "Delete task",
  "planner.trash_task_hint": "Moves it to Trash",
  "planner.trash_target": "Delete task drop target",
  "planner.task_trashed": "Task moved to Trash",
  "periods.zoom_group": "Zoom",
  "periods.drag_cancelled": "Move cancelled",
  "periods.placed_range": "{{value1}} now runs {{value2}}"
}
